import { render, staticRenderFns } from "./LottieIcon.vue?vue&type=template&id=99f24706&scoped=true&"
import script from "./LottieIcon.vue?vue&type=script&lang=js&"
export * from "./LottieIcon.vue?vue&type=script&lang=js&"
import style0 from "./LottieIcon.vue?vue&type=style&index=0&id=99f24706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f24706",
  null
  
)

export default component.exports